import { signInWithRedirect } from "aws-amplify/auth";
import { ReactElement } from "react";

import { Button } from "../components/catalyst/Button";

const SignIn = (): ReactElement => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="w-96 rounded-lg bg-white p-8 text-center shadow-md">
        <h1 className="mb-2 text-2xl font-bold">Sign in to your account</h1>

        <Button onClick={() => signInWithRedirect()}>Sign in</Button>
      </div>
    </div>
  );
};

export default SignIn;
